import React from 'react';

import SlackIcon from '../../images/icons/slack.svg';

export const SlackLogo = () => {
  return <img height="18" src={SlackIcon} alt="Slack logo" />;
};
